// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__YVTR3","file":"styles_file__3Yr9G"};